// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTESTS_ADD_REPLY = "Zapoj se do sout\u011b\u017ee...";
export const FORUM_ADD_REPLY = "Sem za\u010dni ps\u00e1t odpov\u011b\u010f...";
export const FORUM_COMMENT_EDIT_TEXT = "Odpov\u011b\u010f";
export const FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT = "Pr\u00e1zdnou zpr\u00e1vu nem\u016f\u017ee\u0161 odeslat";
export const SEND_ANONYMOUSLY = "Ode\u0161li anonymn\u011b";
export const SEND_AS_ADMIN = "oznam MK";
export const SEND_COMMENT_FORUM = "Ode\u0161li";
